module.exports = __webpack_public_path__ + "img/deep-analysis.66390a02.svg";